<template>
  <div class="cx-showcase-section cxu-pt-10" :id="name">
    <div class="cx-showcase-section__header"><a :href="link" target="_blank" rel="noopener noreferrer"><h1>{{ name }}</h1></a></div>
    <div class="cx-showcase-section__content cxu-display-flex-column cxu-mt-20"><slot></slot></div>
  </div>
</template>

<script>

export default {
  name: 'CxShowcaseSection',
  props: {
    name: { type: String, required: true },
    link: { type: String, required: true }
  }
};

</script>

<style lang="less">
@import '../../common';

.cx-showcase-section__header {
  display: inline-block;
}

</style>

